import { TimelineStatusResponse } from "../../types/timeline";
// TODO: Uncomment when backend API is ready
import base from "../../middlewares/interceptors";
import { executionCheckPointsUrl } from "../constants/index";

/**
 * Fetch timeline status for a specific execution
 *
 * @param executionId - The execution ID to fetch timeline status for
 * @param jobType - The job type (validation, comparison, generic_research_query)
 * @returns Promise<TimelineStatusResponse[]>
 */
export const getTimelineStatus = async (
  _executionId: number,
  jobType: "validation" | "comparison" | "generic_research_query" = "validation"
): Promise<TimelineStatusResponse[]> => {
  try {
    // TODO: Replace with actual API call when backend is ready
    const params = new URLSearchParams();
    params.append("job_type", jobType);
    const response = await base.get(
      `${executionCheckPointsUrl}/${_executionId}?${params.toString()}`
    );
    return response.data;

    //return MOCK_TIMELINE_STATUS_ONE;
  } catch (error) {
    console.error("Failed to fetch timeline status:", error);
    throw error;
  }
};
